export const getParkingFilterQueryParams = () => {
  let queryParams = "";

  if (localStorage.parkingFilter) {
    let filter = JSON.parse(localStorage.parkingFilter);
  
    if (filter.filterEvCharging === true)
      queryParams += "&filterEvCharging=true";
    if (filter.filterHot === true)
      queryParams += "&filterHot=true";
    if (filter.filterReserved === true)
      queryParams += "&filterReserved=true";
    if (filter.filterLanded === true)
      queryParams += "&filterLanded=true";
    if (filter.filterApartment === true)
      queryParams += "&filterApartment=true";
    if (filter.filterCommercial === true)
      queryParams += "&filterCommercial=true";
    if (filter.minPrice !== null && filter.minPrice !== "" && filter.minPrice !== "null") 
      queryParams += `&minPrice=${filter.minPrice}`;
    if (filter.maxPrice !== null && filter.maxPrice !== "" && filter.maxPrice !== "null") 
      queryParams += `&maxPrice=${filter.maxPrice}`;
  }
  
  return queryParams;
}